<template>
  <div>
    <Modal :options="{width: '40vw'}">
      <div class="title">Editar usuario</div>
      <div class="body">
        <div class="row form-group">
          <label for="" class="col-form-label col-sm-3">Usuario</label>
          <div class="col-sm-9">
            <select v-model="usuario_tmp.account_id" name="" id="" class="form-control" disabled>
              <option v-for="usuario in usuarios_account" :value="usuario.id">{{ usuario.nombre }}</option>
            </select>
          </div>
        </div>

        <div class="row form-group">
          <label for="" class="col-form-label col-sm-3">Estatus</label>
          <div class="col-sm-9">
            <BpBSwitch v-model="usuario_tmp.estatus" label="Activo" />
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary mr-2" @click="actualizar_usuario">Guardar</button>
            <button class="btn btn-danger" @click="$emit('close')">Cancelar edición</button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/components/Modal';
  import BpBSwitch from '@/components/Form/Switch'

  import apiAccount from '@/apps/tickets/api/account';
  import apiAreas from '@/apps/tickets/api/areas';

  export default {
    components: {
      Modal, BpBSwitch
    },
    props: {
      area: {
        type: Object,
        default() {
          return {
            id: null
          }
        }
      },
      usuario: {
        type: Object,
        default() {
          return {
            id: null,
            account_id: null,
            nombre: null,
            estatus: 0
          }
        }
      }
    },
    data() {
      return {
        usuario_tmp: {
          id: null,
          account_id: null,
          nombre: null,
          estatus: 0
        },
        usuarios_account: [],
      }
    }
    ,mounted() {
      this.usuario_tmp = this.$helper.clone(this.usuario);
      this.obtener_usuarios_account();
    }
    ,methods: {
      async obtener_usuarios_account() {
        try {
          this.usuarios_account = await this.$helper.cache_store('tickets_account_users', async () => {
            return (await apiAccount.obtener_usuarios()).data;
          });
        }catch(e) {
          this.$log.info('error',e);
          this.$helper.showAxiosError(e,'Error');
        }
      }
      ,async actualizar_usuario() {
        try {
          let res = (await apiAreas.editar_usuario(this.area.id, this.usuario_tmp.id, this.usuario_tmp)).data;
          this.$log.info('res', res);

          this.$emit('update');
        }catch(e) {
          this.$log.info('error',e);
          this.$helper.showAxiosError(e,'Error');
        }
      }
    }
  }
</script>